import React from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { timelineDataSelector } from '@store/timeline/data/selectors';
import { configGranularitySelector } from '@store/timeline/config/selectors';
import { TIMELINE_DIMENSION } from '@components/session-timeline/utils/constants';
import errorImpact from '@components/session-timeline/utils/errorImpact';
import { defaultColumns } from '../constants';
import { getLinerData } from '../utils';

export const useData = (event: string, dateRange: number[]) => {
  const timelineData = useSelector(timelineDataSelector);
  const granularity = useSelector(configGranularitySelector);
  const min = moment(dateRange[0]);
  const max = moment(dateRange[dateRange.length - 1]);
  let data = (get(timelineData, [event], []) as any[]).filter((row) => {
    const time = row.timeMs || 0;
    const startTime = row.startTimeMs || 0;
    const endTime = row.endTimeMs || 0;
    if (time > 0) {
      return moment(time).isBetween(min, max, granularity, '[]');
    }
    const startMoment = moment(startTime);
    const endMoment = moment(endTime);
    return startMoment.isBetween(min, max, granularity, '[]') && endMoment.isBetween(min, max, granularity, '[]')
      || startMoment.isSameOrBefore(min, granularity) && endMoment.isSameOrAfter(max, granularity)
      || startMoment.isBetween(min, max, granularity, '[]') && endMoment.isSameOrAfter(max, granularity)
      || startMoment.isBefore(min, granularity) && endMoment.isSameOrAfter(max, granularity);
  });
  if (([TIMELINE_DIMENSION.Bitrate, TIMELINE_DIMENSION.Framerate] as string[]).includes(event)) {
    data = getLinerData(data, event);
  }
  const columns = defaultColumns[event] || [];

  const cacheData = React.useMemo(() => data.map((row) => columns.reduce((result, column) => {
    if (column.dataKey === 'time') {
      result[column.dataKey] = row.timeMs || row.time || 0;
    } else if (column.dataKey === 'errorType') {
      result[column.dataKey] = errorImpact(get(row, 'value', {}));
    } else if (typeof row.value === 'object') {
      result[column.dataKey] = row.value[column.dataKey] || 0;
    } else {
      result[column.dataKey] = row[column.dataKey] || '';
    }
    return result;
  }, {})), [data, columns]);
  return cacheData;
};
